import "./Home.css"


import { Globalalert, Navbar, Footer, Contact, Stats } from '../../components'
import { FaRegCalendarAlt, FaShoppingBag } from "react-icons/fa";
import { GiCookingPot } from "react-icons/gi";


import { Helmet } from 'react-helmet'

import recipesList from '../../data/recipesList';

function Home() {
    const globalAlertItems = {
        body: "Now seeking new farmers market locations in the San Diego area. Interested in hosting my micro-bakery? Contact me via email: jackyjdam@gmail.com",
        ctaText: "",
        ctaURL: ""
    }

    const breadItems = [
    {
        title: "Classic Sourdough Bread",
        price: "$10.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "Rustic Sourdough Boule",
        price: "$10.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "Seeded Sourdough Batard",
        price: "$12.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "Artisan Sourdough Baguette",
        price: "$12.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "Sesame Sourdough Baguette",
        price: "$12.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "Artisan Ciabatta Bread",
        price: "$8.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    }
    ];

    const cookieItems = [
    {
        title: "Classic Chocolate Chip Cookies",
        desc: "It took me many, many attempts until I landed on a classic chocolate chip recipe I was happy selling. How can you go wrong with a classic?",
        price: "$10.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "White Chocolate Matcha Cookies",
        desc: "A premium matcha product, the first of many asian inspired cookies. These are pretty darn good if you like matcha.",
        price: "$12.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "White Chocolate Ube Cookies",
        desc: "Introducing the latest flavor featuring Ube, a unique Filipino taste which comes from a sweet purple yam.",
        price: "$12.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "Salted Caramel Chocolate Chip Cookies",
        desc: "A salty, yet delicious treat featuring caramel bits and flakey sea salt.",
        price: "$10.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    {
        title: "Funfetti Cookies",
        desc: "One of my favorite classic cookies, almost cake-like but like you don't have to eat it just on birthdays.",
        price: "$10.00",
        img: "/cookies.png",
        link: "https://jds-kitchen.square.site"
    },
    ];

    const recentRecipes = Object.entries(recipesList)
    .map(([slug, data]) => ({ slug, ...data }))
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3)

    return (
        <div id="homepage" className="site">
            <Helmet>
                <title>JD's Kitchen</title>
            </Helmet>
            
            {/* <Globalalert globalAlertItems={ globalAlertItems }/> */}
            <Navbar primaryColor="#fff" position='absolute'/>

            <section className="hero-banner">
                <div className="hero-container">
                    <div className="hero-content">
                        <h1>Your Neighborhood Asian Micro-Bakery.</h1>
                        <p>All sourdough breads, cookies, and baked goods are made fresh in my home kitchen here in Kearny Mesa, San Diego. Handcrafted in small-batches with no preservatives added.</p>
                        <p>This micro-bakery is established with vision of sourcing quality ingredients, supporting reputable businesses, with the goal of some day opening up a bakery location on Convoy Street.</p>
                        <p>Now accepting Pre-Orders below, pick-up @ Kearny Mesa on Sundays from 9am-11am.</p>
                        <div className="btn-primary-container">
                            <a href="https://jds-kitchen.square.site" className="button-74" target="_blank" rel="noopener noreferrer">Pre-Order Now</a>
                        </div>
                    </div>
                    <div className="hero-image-container">
                        <img className="hero-image" src="/hero_background.png"/>
                    </div>
                </div>
            </section>

            <Stats />
            {/* <section className="instagram-section">
                <p>
                    Follow me on Instagram:
                    <a
                    href="https://www.instagram.com/jdskitchenbakes/?utm_source=jdskitchen&utm_medium=contact_form&utm_campaign=social_links"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="instagram-link"
                    >
                    @jdskitchenbakes
                    </a>
                </p>
            </section> */}

            <section id="menu" className="menu">
                <div className="product-aisle">
                    <div className="product-container">
                        <div className="cookie-products">
                        {cookieItems.map((cookie, index) => (
                            <div className="cookie-card" key={index}>
                                <img src={cookie.img} alt={cookie.title} className="cookie-image" loading="lazy" />
                                
                                <div className="cookie-overlay">
                                    <h3 className="cookie-title">{cookie.title}</h3>
                                    <p className="cookie-desc">{cookie.desc}</p>
                                </div>
                                
                            </div>
                            
                        ))}
                        </div>
                        <a
                            href="https://jds-kitchen.square.site"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="button-74"
                        >
                            Shop Now
                        </a>
                    </div>
                </div>

                <br/>

                <div className="product-aisle">
                    <div className="product-container">
                        <h2 className="product-title">Handcrafted in Small-Batches</h2>

                        <div className="bread-products">
                        {breadItems.map((bread, index) => (
                            <div className="bread-card" key={index}>
                            <img src={bread.img} alt={bread.title} className="bread-image" loading="lazy" />
                            <h3 className="bread-title">{bread.title}</h3>
                            <p className="bread-price">{bread.price}</p>
                            <a
                                href={bread.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button-74"
                            >
                                Pre-Order
                            </a>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </section>

           <section className="how-it-works">
                <h2>How It Works</h2>
                <div className="steps-container">
                    <div className="step">
                    <div className="step-icon">
                        <FaRegCalendarAlt size={40} color="#4a90e2" />
                    </div>
                    <h3>Pre‑Order</h3>
                    <p>Place your order before Thursday at 11:59PM via our Square site.</p>
                    </div>

                    <div className="step">
                    <div className="step-icon">
                        <GiCookingPot size={60} color="#4a90e2" />
                    </div>
                    <h3>We Bake Your Order</h3>
                    <p>All items are freshly baked in small-batches in our home kitchen.</p>
                    </div>

                    <div className="step">
                    <div className="step-icon">
                        <FaShoppingBag size={40} color="#4a90e2" />
                    </div>
                    <h3>Pick‑Up</h3>
                    <p>Pick up your baked goods the following Sunday between 9AM‑11AM at Kearny Mesa, San Diego.</p>
                    </div>
                </div>
                </section>





            <Contact />
            {/* <div className="inline-convertkit-form">
                <script async data-uid="ef302e56ce" src="https://jackydam.kit.com/ef302e56ce/index.js"></script>            
            </div> */}
            {/* <Footer /> */}
            

        </div >
    )
}

export default Home